export const projects = [
    {
        id: "5",
        title: "Grosik app",
        pretitle: "Portfolio project",
        img: require('../assets/grosik-img.webp'),
        alt: "An illustrative print screen of the application with the home page.",
        pointOfInterest: 60,
        made_with: ["React (Vite)", "Sass", "Firebase" ],
        collab: ["Karolina Starowicz", "Paweł Pitura"],
        description: "This is an application where everyone can create their shopping list and compare it with prices in different stores. Thanks to this, the user can find the best offers for himself.",
        note: null,
        youtube: null,
        deploy: null,
        github: "https://github.com/propanibutan/grosik-app"
    },
    {
        id: "4",
        title: "Oddaj rzeczy",
        pretitle: "Portfolio project",
        img: require("../assets/oddajrzeczy-img.webp"),
        alt: "An illustrative print screen of the application with the home page.",
        pointOfInterest: 80,
        made_with: ["React (Create React App)", "localStorage", "Sass", "react-router-hash-link", "react-router-dom", "react-paginate", "normalize.css", "Firebase", "Netlify" ],
        collab: ["solo project"],
        description: "The project will be a website with a simple form that will make it easier for users to donate unnecessary items. Features: landing page to encourage the use of the application, a browser application that allows you to return unnecessary items on the basis of an extensive form.",
        note: "App is made with free Firebase, if you want to register but you can't send to me DM.",
        youtube: "https://www.youtube.com/embed/GCrZjopLttw",
        deploy: "https://oddaj-rzeczy-pbz.netlify.app/",
        github: "https://github.com/propanibutan/oddaj-rzeczy"
    },
    {
        id: "3",
        title: "Na Zachętę",
        pretitle: "Hackathon project",
        img: require("../assets/nazachete-img.webp"),
        alt: "An illustrative print screen of the application with the home page.",
        pointOfInterest: 120,
        made_with: ["React (Create React App)", "API Otwarta Zachęta", "Sass", "Figma", "Mural", "GraphQL", "Netlify"],
        collab: ["Arek Rataj", "Bartłomiej Dzięgiel", "Joanna Florczak", "Joanna Jachowicz", "Justyna Rawińska"],
        description: "Project on Hack(art)thon 2022. Landing page with ability to search for images in a search engine. This project follows the accessibility rules very restrictively. Our goal was to make students more emotionally involved in lessons, make art more appealing for them, and help teachers access high-quality art reproductions in a short time. This project aims to create games for students that will be easy to use for teachers and students.",
        note: "Check the video to be more insightful. On deploy is the only landing page for presentation purposes.",
        youtube: "https://www.youtube.com/embed/QDh7EhskZXA",
        deploy: "https://zacheta-hackarton.netlify.app/",
        github: "https://github.com/propanibutan/hackarton-zacheta-dla-sztuki"
    },
    {
        id: "2",
        title: "Plants Care App",
        pretitle: "CodersLab's final project",
        img: require("../assets/plantcareapp-img.webp"),
        alt: "An illustrative print screen of the application with the home page.",
        pointOfInterest: 260,
        made_with: ["React (Create React App)", "Firebase", "Material UI", "Netlify", "validator.js" ],
        collab: ["solo project"],
        description: "An application that helps in caring for plants. The user can create a base of his plants. Features: registration and login form, adding a plant with features and your own photo (form), browsing your plant database.",
        note: "App is made with free Firebase, if you want to register but you can't send to me DM.",
        youtube: null,
        deploy: "https://plant-care-app.netlify.app/",
        github: "https://github.com/propanibutan/care-plants-app"
    },
    {
        id: "1",
        title: "Zaplanuj Jedzonko",
        pretitle: "Scrum CodersLab's project",
        img: require("../assets/zaplanujjedzonko-img.webp"),
        alt: "An illustrative print screen of the application with the home page.",
        pointOfInterest: 200,
        made_with: ["javascript", "localStorage", "SASS", "Gulp" ],
        collab: ["Katarzyna Zielińska", "Krzysztof Korbiński", "Wiktor Richter"],
        description: "The main site for a meal planning application. Each user will be able to manage their meal list, even after closing the browser. Features: landing page to encourage the use of the application, A browser application that allows you to: add, modify and delete recipes, view the recipe list, create, view and modify the weekly nutrition schedule.",
        deploy: null,
        github: "https://github.com/propanibutan/zaplanuj-jedzonko"
    }
]

export const openSpring = { type: "spring", stiffness: 200, damping: 30 };